import React from "react";

interface CardProps {
    children: React.ReactNode;
    className?: string;
    title?: string;
    description?: string;
}

const Card: React.FC<CardProps> = ({ children, className = "", title, description }) => {
    return (
        <div className={`bg-fin-surface rounded-xl shadow-lg border border-gray-100 overflow-hidden ${className}`}>
            {(title || description) && (
                <div className="px-6 py-5 border-b border-gray-100 bg-surface-50">
                    {title && <h3 className="text-lg font-semibold text-gray-900 leading-6">{title}</h3>}
                    {description && <p className="mt-1 text-sm text-gray-500">{description}</p>}
                </div>
            )}
            <div className="p-6">
                {children}
            </div>
        </div>
    );
};

export default Card;
